/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
// apis
import { getCardPurchaseAllExcel, getCardRecordsPurchaseList } from "../../../../apis/finances/cards";
// components
// utils
import { classnames } from "../../../../utils/text";
import { isVerticalImg } from "../../../../utils/image";
import { cardName } from "../../../../utils/account-name";
import defaultCardImage from "../../../../assets/images/bank-card-images/default-card-img.png";

import { ControlTable } from "../../../../components/Table";
import { transformComma } from "../../../../utils/validator/comma";
import useForm from "../../../../hooks/useForm";
import { getParams } from "../../../../utils/params";
import { isEmpty } from "../../../../utils/lodashExtend";
import { findIndex } from "lodash";
import { downExcelFile } from "../../../../utils/download";
import { comma, getOnlyNumber } from "../../../../utils/number";
import { useHistory } from "react-router-dom";
import { getFinanacesScrapingHistoryList, scrapingFinanaces } from "../../../../apis/finances/auth";
import systemAlert from "../../../../utils/systemAlert";
import { dateToFormat } from "../../../../utils/date";
import { viewLoading } from "../../../../utils/loading";
import IconButton from "../../../../components/Button/IconButton";
import DeleteIcon from "../../../../assets/images/icon/delete-icon-01.svg";
import { deleteAccountingTitle } from "../../../../apis/finances/accounting-title";
import CategoryMappingModal from "../../../../components/Bank/CategoryMappingModal";

const ByPurchaseTable = ({ data, params = {}, scrapingPermission, cardScrapings, cardHistoryPermission }) => {

  const [sortFields, setSortFields] = useState([
    { key: "useTime", order: 'desc' },
    { key: "useAmt", order: '' },
  ]);
  const [fields, setFields] = useState([]);

  const [reload, setReload] = useState(false);
  const [isScraping, setIsScraping] = useState(false);
  const [timerValue, setTimerValue] = useState(0);
  const [financeScraping, setFinanceScraping] = useState({});
  const [isCategoryMappingOpen, setIsCategoryMappingOpen] = useState(false);

  const history = useHistory();
  const timerId = useRef(null);

  useEffect(() => {
    if (scrapingPermission && !isEmpty(cardScrapings) && !isEmpty(data)) {
      const scraping = cardScrapings.find(f => f.cardIdx === data.idx);
      setFinanceScraping(scraping);
    }
  }, [scrapingPermission, cardScrapings]);

  useEffect(() => {
    setFields([
      { title: '거래일자', key: 'useTime', type: 'date', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: '승인금액(원화)', key: 'useAmt', type: 'comma', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: '승인금액(외화)', key: 'useExAmt', onValue: (v, _f, d) => v > 0 ? `${comma(v)}${!isEmpty(d.exCurCd) ? ` ${d.exCurCd}` : ""}` : '0' },
      { title: '거래타입', key: 'useDiv' },
      { title: "상태", key: "apprSt" },
      { title: '가맹점', key: 'useStore' },
      { title: '업종', key: 'storeType' },
      { title: '사업자번호', key: 'storeBizNo', transform: 'comNum' },
      { title: '가맹점전화번호', key: 'storeTel' },
      {
        title: '카테고리',
        key: 'accountingTitleUses',
        onValue: (value) => {
          return (
            !isEmpty(value) &&
            value.map((category, idx) => (
              <div className="text-align-right" key={idx}>
                <p className="pt-8 pb-8">
                  <span className="vertical-middle">{category.accountingTitle.name}</span>
                  {cardHistoryPermission.level > 1 && (
                    <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveCategory(category)} />
                  )}
                </p>
              </div>
            ))
          );
        }
      }
    ]);
  }, [sortFields, cardHistoryPermission]);

  const handleRemoveCategory = (category) => {
    systemAlert(`매핑된 카테고리(${category.accountingTitle.name})를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            deleteAccountingTitle(category.idx)
              .then(() => {
                filterSubmit();
              })
              .catch(() => { })
              .finally(() => { });
          }
        }
      ]
    });
  };


  useEffect(() => {
    timerId.current = setInterval(() => {
      setTimerValue(1);
    }, 1000 * 5);
    return () => clearInterval(timerId.current);
  }, []);

  useEffect(() => {
    if (timerValue === 1 && !isEmpty(scrapingPermission) && scrapingPermission.level > 1) {
      setTimerValue(0);
      if (reload && !isEmpty(financeScraping)) {
        getHistories(financeScraping);
      }
    }
  }, [timerValue]);

  const getHistories = (financeScraping) => {
    getFinanacesScrapingHistoryList(financeScraping.idx, { search: { state: 9 } })
      .then(res => {
        if (!isEmpty(res.data.histories)) {
          setReload(true);
          setIsScraping(true);
        } else {
          setReload(false);
          setIsScraping(false);
          reSubmit(form);
        }
      });
  };

  const rowBtnConfig = {
    title: '카테고리 매핑',
    rowButtons: [
      {
        type: "edit",
        className: "mr-4",
        action: (data) => {
          setSelectedList([data]);
          setIsCategoryMappingOpen(true);
        },
      },
    ],
  };

  const {
    form,
    setForm,
    setSubmit,
    // LIST 용
    filterSubmit,
    handleSubmit,
    list, setList,
    isLoading, setIsLoading,
    page, setPage,
    limit, setLimit,
    total, setTotal,
    setOrderBy,
    setSelectedList,
    selectedList,
    reSubmit
  } = useForm(
    {
      useAmt: 0,
      search: {
        useStore: ""
      },
      cardIdxes: [],
      range: {
        useTime: []
      },
      order: [
        { useTime: 'desc' }
      ],
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }
  }, [sortFields]);

  useEffect(() => {
    setSubmit(submit);
  }, []);

  useEffect(() => {
    if (!isEmpty(params)) {
      const _params = {
        ...form,
        useAmt: Number(getOnlyNumber(params.useAmt)) > 0 ? Number(getOnlyNumber(params.useAmt)) : 0,
        search: {
          useStore: params.search.useStore
        },
        cardIdxes: [data.idx],
        range: {
          useTime: [params.range.useDate[0], params.range.useDate[1]]
        },
      };
      setForm(_params);
      filterSubmit({
        params: _params
      });
    }
  }, [data]);

  const submit = (params) => {
    setIsLoading(true);
    getCardRecordsPurchaseList(getParams(params))
      .then((res) => {

        setList(res.data.purchaseList);
        setTotal(res.data.totalCount);
      })
      .catch(() => { })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getTitle = () => {
    return (
      <div className="by-purchase-card-title">
        <div
          className={classnames("card-img-wrap", {
            vertical: isVerticalImg(data.cardImg),
          })}
        >
          <img src={data.cardImg || defaultCardImage} alt={data.cardCompany} onError={(e) => e.target.src = defaultCardImage} />
        </div>
        <div className="card-info-wrap">
          <p className="card-name-text">{`${cardName(data.cardCdName, data.cardNo)}`}<span className="card-full-name">{data.cardName}</span></p>
          <p className="card-use-amount-text">{`총 승인금액 ${transformComma(data.useAmtSum)}원`}</p>
        </div>
      </div>
    );
  };

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };

  const tableButtons = [
    {
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      color: "gray-line",
      action: () => {
        const from = params.range.useDate[0];
        const to = params.range.useDate[1];
        const card = cardName(data.cardCdName, data.cardNo);
        const body = {
          range: {
            useDate: {
              from,
              to
            }
          },
          cardIdx: data.idx
        };
        getCardPurchaseAllExcel(body).then((res) => {
          downExcelFile(res, `${card} 매입 건별 내역 ${from}~${to} .xlsx`);
        });
      },
      disabled: isEmpty(list)
    },

    {
      label: "거래내역 스크래핑",
      disabled: isScraping,
      isHide: isEmpty(financeScraping) || isEmpty(scrapingPermission) || 1 >= scrapingPermission.level,
      action: () => {
        systemAlert("수동 스크래핑을 진행하시겠습니까?", {
          buttons: [
            {
              label: "취소",
              color: "text"
            }, {
              label: "스크래핑",
              onClick: () => {
                const params = {
                  svcCd: "C0005",
                  sdate: dateToFormat(new Date(), 'YYYYMMDD'),
                  edate: dateToFormat(new Date(), 'YYYYMMDD')
                };
                viewLoading(true);
                scrapingFinanaces(financeScraping.idx, params)
                  .then(() => {
                    setReload(true);
                    setIsScraping(true);
                    systemAlert(
                      <>
                        <p>스크래핑 요청에 성공하였습니다.</p>
                        <p>스크래핑이 완료될 때까지 일정시간이 소요됩니다.</p>
                        <p className="color-red-100">수집이력 내역 반영까지 일정시간이 소요됩니다.</p>
                        <p> 관리자 -&gt; 금융정보 자동 수집 -&gt; 수집이력에서</p>
                        <p>스크래핑 결과를 확인하실 수 있습니다.</p>
                      </>
                      , {
                        buttons: [
                          {
                            label: "수집이력 확인하기",
                            onClick: () => {
                              history.push("/manager/financial?tab=scraping-history");
                            }
                          },
                          {
                            label: "확인",
                            onClick: () => {
                              getHistories(financeScraping);
                            }
                          },
                        ]
                      });
                  })
                  .catch(() => { })
                  .finally(() => {
                    viewLoading(false);
                  });
              }
            }
          ]
        });
      }
    }
  ];

  return (
    <>
      <ControlTable
        isLoading={isLoading}
        title={getTitle()}
        fields={fields}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        buttons={tableButtons}
        list={list}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        submit={handleSubmit}
        rowBtn={cardHistoryPermission?.level > 1 ? rowBtnConfig : {}}
      />

      <CategoryMappingModal
        open={isCategoryMappingOpen}
        setOpen={setIsCategoryMappingOpen}
        selectedItem={selectedList}
        setSelectedItem={setSelectedList}
        useType="card_purchase"
        submit={filterSubmit}
      />
    </>
  );
};

export default ByPurchaseTable;
